// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
export let CustomButtonsGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.CUSTOM_BUTTONS_GROUP, null, pfixFieldSet)
}
CustomButtonsGroup.prototype = Object.create(PFixFieldSet.prototype)

CustomButtonsGroup.prototype.getTitle = function ()
{
    return this.GetValue(FieldsFactory.FIELD_TITLE);
}
CustomButtonsGroup.prototype.getTooltip = function ()
{
    return this.GetValue(FieldsFactory.FIELD_TOOLTIP);
}
CustomButtonsGroup.prototype.getURL = function ()
{
    return this.GetValue(FieldsFactory.FIELD_URL);
}
CustomButtonsGroup.prototype.getCustomButtonNumber = function ()
{
    return this.GetValue(FieldsFactory.FIELD_NUMBER);
}